import React from "react";
import { usePostHog } from "posthog-js/react";
import { Button } from "./ui/button";
import useConsentStore from "../store/useConsentStore";
import ConsentPreferencesDialog from "./ConsentPreferencesDialog";
import { PRIVACY_POLICY_URL } from "../utils/privacyConsent";

const ConsentBanner = () => {
  const posthog = usePostHog();
  const {
    bannerVisible,
    consentGiven,
    gpcDetected,
    acknowledgeBanner,
    openPreferences,
    dismissBanner,
  } = useConsentStore();

  return (
    <>
      {bannerVisible && (
        <div
          role="dialog"
          aria-label="Privacy consent"
          aria-live="polite"
          className="fixed bottom-4 right-4 z-[100] w-[calc(100vw-2rem)] max-w-sm rounded-lg border border-border bg-white p-4 shadow-lg sm:max-w-md sm:p-5">
          <div className="flex flex-col gap-4">
            <div>
              <h2 className="text-base font-semibold text-optonyblue">Your Privacy Choices</h2>
              <p className="mt-2 max-h-48 overflow-y-auto text-sm text-muted-foreground">
                We use strictly necessary cookies and local storage to keep you signed in and run
                this application, and utilize third-party analytics to improve user experience. You
                have the right to opt out of the sale or sharing of personal information and to
                limit use of sensitive data.{" "}
                {gpcDetected && (
                  <>
                    We detected a Global Privacy Control signal in your browser and have disabled
                    analytics by default.{" "}
                  </>
                )}
                See our{" "}
                <a
                  href={PRIVACY_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-optonyprimary underline underline-offset-2">
                  Privacy Policy
                </a>{" "}
                for details.
              </p>
            </div>

            <div className="flex flex-col gap-2">
              {!gpcDetected && (
                <Button
                  onClick={() => acknowledgeBanner(posthog)}
                  className="w-full">
                  Accept all
                </Button>
              )}
              {gpcDetected && consentGiven && (
                <Button
                  variant="ghost"
                  onClick={dismissBanner}
                  className="w-full">
                  Dismiss
                </Button>
              )}
              <Button
                variant="outline"
                onClick={openPreferences}
                className="w-full">
                Manage Preferences
              </Button>
            </div>
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={openPreferences}
        className={`fixed bottom-4 z-[90] rounded-md border border-border bg-white px-3 py-1.5 text-xs text-optonyblue shadow-sm transition-colors hover:bg-gray-50 ${
          bannerVisible ? "left-4" : "right-4"
        }`}>
        Cookie Settings
      </button>

      <ConsentPreferencesDialog />
    </>
  );
};

export default ConsentBanner;
